import React from 'react';
import GAPCategoryFilter from './filters/GAPCategoryFilter';
import { css } from '@linaria/core';

const gapNotice = css`
  background-color: #d1e1fb;
  border: 1px solid #4786ed;
  margin-top: 40px;
  padding: 30px;
  position: relative;

  &:before {
    background-color: #cccccc;
    content: '';
    height: 1px;
    left: 0;
    position: absolute;
    top: -20px;
    width: 100%;
  }
`;

const GAPSearchFilters = () => {
  return (
    <>
      <GAPCategoryFilter />

      <div className={gapNotice}>
        The extent of public access and opening times vary from one property to
        another. Please check each place&#39;s website or contact them directly.
      </div>
    </>
  );
};

export default GAPSearchFilters;
